<template>
  <div class="page">
    <ActionBar :breadcrumbItems="breadcrumbItems">
      actions
    </ActionBar>

    <div class="page--content">
      RevenuesPage
    </div>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'
import ActionBar from 'components/Actionbar'

export default {
  name: 'RevenuesPage',
  components: {
    ActionBar
  },
  data () {
    return {
      breadcrumbItems: [
        { title: this.$t('Common.financial') },
        { name: 'Revenues', title: this.$t('Views.RevenuesPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
